import React from 'react';

interface ButtonProps {
    onClick?: (event: React.MouseEvent<HTMLDivElement>) => void
}

const AddButton = (props: ButtonProps) => {
    return (
        <div className='add-button' onClick={(e) => props.onClick(e)}></div>
    )
}
export default AddButton;